import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "md-typescale-body-large bold" }
const _hoisted_3 = { class: "md-typescale-body-large" }
const _hoisted_4 = { class: "layout-container" }
const _hoisted_5 = { class: "mobile-only logout-wrapper" }
const _hoisted_6 = { class: "content" }

import { useAuth } from '@/composables/useAuth';
import MainLayout from '@/layout/MainLayout/MainLayout.vue';
import Flex from '@/components/Flex/Flex.vue';
import Button from '@/components/Button/Button.vue';
import LogoutIcon from '@/components/Icons/Logout.vue';
import { useI18n } from 'vue-i18n';
import { onBeforeUnmount, onMounted, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import Logo from '@/components/Logo/Logo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoggedLayout',
  setup(__props) {

const auth = useAuth();
const { t } = useI18n();
const route = useRoute();
const menuOpen = ref(false);
const sidebar = ref<HTMLElement | null>(null);
const hamburger = ref<HTMLElement | null>(null);

const isActive = (path: string) => computed(() => route.path.startsWith(path));

const handleClickOutside = (event: MouseEvent) => {
  if (
    menuOpen.value &&
    sidebar.value &&
    !sidebar.value.contains(event.target as Node)
  ) {
    if (hamburger.value && !hamburger.value.contains(event.target as Node)) {
      menuOpen.value = false;
    }
  }
};

const logout = () => {
  auth.logout();
};

onMounted(() => {
  document.addEventListener('logout', logout);
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('logout', logout);
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Flex, {
          justify: "between",
          align: "center",
          class: "mobile-col",
          gap: 3
        }, {
          default: _withCtx(() => [
            _createVNode(Flex, {
              gap: 3,
              justify: "start",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    ref_key: "hamburger",
                    ref: hamburger,
                    class: "hamburger",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (menuOpen.value = !menuOpen.value))
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("span", { class: "material-icons" }, "menu", -1)
                  ]))], 512)
                ]),
                _createVNode(Logo, {
                  width: 72,
                  height: 72
                }),
                _createElementVNode("div", null, [
                  _createVNode(Flex, {
                    direction: "column",
                    gap: 1,
                    class: "phone-info"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('general.phone_number')), 1),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(auth).user.value?.phoneNumber || ' '), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(Flex, {
              justify: "end",
              class: "desktop-only"
            }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  label: _unref(t)('general.logout'),
                  disabled: _unref(auth).logoutLoading.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(auth).logout()))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(LogoutIcon)
                  ]),
                  _: 1
                }, 8, ["label", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (menuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "overlay",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (menuOpen.value = false))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("nav", {
          ref_key: "sidebar",
          ref: sidebar,
          class: _normalizeClass(['sidebar', { open: menuOpen.value }]),
          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(['nav-item', { active: isActive('/devices').value }]),
            to: "/devices",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "material-icons" }, "devices", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)('nav.devices')), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          (_unref(auth).user.value?.emergencyContact)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: _normalizeClass([
            'nav-item',
            { active: isActive('/emergency-contacts').value },
          ]),
                to: "/emergency-contacts",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (menuOpen.value = false))
              }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "material-icons" }, "contact_phone", -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('nav.emergency_contacts')), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            class: _normalizeClass(['nav-item', { active: isActive('/settings').value }]),
            to: "/settings",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "material-icons" }, "settings", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)('nav.settings')), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Button, {
              label: _unref(t)('general.logout'),
              disabled: _unref(auth).logoutLoading.value,
              onClick: _cache[6] || (_cache[6] = ($event: any) => {
              _unref(auth).logout();
              menuOpen.value = false;
            })
            }, {
              icon: _withCtx(() => [
                _createVNode(LogoutIcon)
              ]),
              _: 1
            }, 8, ["label", "disabled"])
          ])
        ], 2),
        _createElementVNode("main", _hoisted_6, [
          (_unref(auth).user.value)
            ? _renderSlot(_ctx.$slots, "default", { key: 0 })
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }))
}
}

})